module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-48.b465c2f9.png";